import { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Box, Chip } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import QuillEditor from 'src/components/quill-editor';
import { getImg } from 'src/services/AssetApi';
import ZoomImage from 'src/components/zoom-image';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import { validationSchema, handleSubmitted } from './formik';
import StringTextField from 'src/components/widgets/string-textfield';

export const DetailForm = (props) => {
  const { item, apiSendBill, apiSendTicket, apiUnsendTicket, ...other } = props;
  const imageSrc = useMemo(() => getImg(item.asset?.name), [item.asset?.name]);
  
  const [submitState, setSubmitState] = useState({ verified: false });
    
  const formik = useCustomFormik({
    initialValues: { smsField: null },
    validationSchema: validationSchema(),

    onSubmit: async (values) => {
      await handleSubmitted(values, item, apiSendBill, apiSendTicket, apiUnsendTicket);
    },
  });

  useEffect(() => {  
    if (item) {
      setSubmitState(prev => ({ 
        ...prev,
        reason: item.ticket?.reason,
        verified: !!item.ticket
      }));

      // Map through item.assets array and update the name for each object
      const updatedAssets =
        item.evidences?.map((img) => ({
          ...img,
          name: getImg(img.name),
          selected: img.thumb,
          readonly: true,
          disabled: !img.thumb,
        })) || [];
      // Set formik field with the updated assets array
      formik?.setFieldValue('defaultImgs', updatedAssets);
    }
  }, []);

  const handleVerify = (isChecked) => {
    let reason = item?.ticket?.reason;
    if(reason){
      reason = isChecked ? reason : 'Hủy thông báo';
    }
    setSubmitState(prev => ({ 
      ...prev,
      reason: reason,
      verified: isChecked
    }));
  };

  return (
    <form onSubmit={formik.handleSubmit} {...other}>
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={3} alignItems="flex-start">
          <Grid xs={12} md={6} container spacing={3}>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Biển số"  value={item.car?.name} />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Tổng tiền" value={item.price} enumType="decimal" />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="ODO bảo dưỡng" value={item.atKm} enumType="decimal" />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Ngày bảo dưỡng"  value={item.atTime} dateFormat="dd/MM/yyyy" />
            </Grid>
            <Grid xs={12} md={12}>
              <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                {Array.isArray(item.services) && item.services.map((option) => (
                  <Chip
                    key={option.value}
                    label={option.label}
                    sx={{
                      m: 0.5,
                      p: 0.5,
                      '& .MuiChip-label': {
                        fontSize: '0.9rem'
                      }
                    }}
                  />
                ))}
              </Box>
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Liên hệ"  value={item.contact?.name} />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Số điện thoại" value={item.contact?.phone} enumType="phone" />
            </Grid>

            <Grid xs={12} md={12}>
              <StringTextField
                label="Nội dung"
                name="smsField"
                formik={formik}
                hintValue={submitState.reason}
              />
            </Grid>
            {/* Web Browser & Mobile */}
            <Grid xs={12}
                sx={{
                  display: { xs: 'center', md: 'flex' },
                  justifyContent: { xs: 'center', md: 'flex-end' }
                }}>
              <SubmitButton formik={formik} isRemove={true} labelRemove={'Gửi thông báo'} 
                hasVerified={submitState.verified} onVerifyChange={handleVerify} />
            </Grid>
          </Grid>
          
          <Grid xs={12} md={6}>
            <><Grid container spacing={3}>
                <Grid xs={12}>
                  <QuillEditor
                    value={item.note}
                    isReadOnly={true}
                    sx={{height: 75}}
                  />
                </Grid>
                <Grid xs={12}>
                  <ZoomImage
                    thumbSrc={imageSrc}
                    zoomSrc={imageSrc}
                    height="360"
                    frame="auto"
                  />
                </Grid>
              </Grid>
            </>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
    </form>
  );
};

DetailForm.propTypes = {
  item: PropTypes.object.isRequired,
  apiPayment: PropTypes.func,
};